// Default method
var LayoutInitChild = function () {
    this._childrenWidth = undefined;
    this._childrenHeight = undefined;
}
export default LayoutInitChild;